export const APPLICATION_HEADER_HEIGHT = 86;
export const ELEVATION_PROFILE_CHART_Y_EXTRA_PADDING = 10;
